import { type TAutoInsuranceInfo } from '@/types/avtoInsuranceInfo';
import { type TClientInsuranceInfo } from '@/types/clientInsurance';
import { type TInsuranceInfo } from '@/types/insuranceInfo';
import { type TInsuranceDetailed } from '@/types/insuranseServer';
import { type TPersonInsuranceInfo } from '@/types/personInfo';
import { type TProductInsuranceInfo } from '@/types/productInfo';

export const insuranceItemMapper = (
  insurance: TInsuranceDetailed
): {
  autoInsuranceInfo: TAutoInsuranceInfo;
  clientInsuranceInfo: TClientInsuranceInfo;
  insurance: TInsuranceInfo;
  personalInsuranceInfo: TPersonInsuranceInfo;
  productInsuranceInfo: TProductInsuranceInfo;
} => {
  const model = insurance.model;

  return {
    autoInsuranceInfo: {
      dateOfTechPasspord: insurance.vehicle_passport_issue_date || '',
      dealer: insurance.dealer?.code.toString() || '',
      markModelYear: {
        ...(model && model.brand
          ? {
              brand: {
                code: String(model.brand.code),
                name: model.brand.name
              }
            }
          : {}),
        ...(model
          ? {
              model: {
                code: String(model.code),
                name: model.name
              }
            }
          : {}),
        year: insurance.year || ''
      },
      numberGos: insurance.vehicle_body_number || '',
      priseAvto: insurance.vehicle_cost || '',
      tehNum: insurance.tech_pass_num || '',
      vinCode: insurance.vin_code || ''
    },

    clientInsuranceInfo: {
      innInsurance: insurance.client?.client_iin || '',
      numberInsurance: insurance.doc_num || ''
    },

    insurance: {
      insuransePremium: insurance.insurance_prem || '',
      insuranseSumm: insurance.insurance_summ || ''
    },

    personalInsuranceInfo: {
      address: insurance.address || '',
      clientIin: insurance.client?.client_iin || '',
      clientPhone: insurance.client?.phone_number || '',
      dateBirth: insurance.client?.birth_date || '',
      dateDocument: insurance.document_registration_date || '',
      docType: insurance.document_type?.code.toString() || '',
      email: insurance.email || '',
      firstName: insurance.client?.first_name || '',
      issuebdy: insurance.issuing_organisation_authority?.code.toString() || '',
      lastName: insurance.client?.last_name || '',
      middleName: insurance.client?.middle_name || '',
      numberdocument: insurance.doc_num || '',
      resident: insurance.resident_status?.code.toString() || '',
      sex: insurance.gender?.code.toString() || '',
      validity: insurance.document_valid_date || ''
    },

    productInsuranceInfo: {
      dateEndpolis: insurance.end_date || '',
      dateForm: insurance.create_date || '',
      datepolis: insurance.contract_date || '',
      payment: insurance.payment_types?.code.toString() || '',
      paymentType: insurance.installment_types?.code.toString() || '',
      productType: insurance.product_type?.code || '',
      productTypeDate: insurance.installment_periods?.code.toString() || '',
      status: insurance.status,
      isKdpActive: insurance.is_kdp
    }
  };
};
